import {useRef,useEffect, useState} from 'react';
import { useSelector,useDispatch } from 'react-redux';
import { modalModifShow,modif,update,current } from "./ClientsSlice";
import axios from 'axios';

export default function ModalModifer() {

    const Clientsdata = useSelector(state => state.clientsData);
    const currentelement = Clientsdata.current;
    const modalShow = Clientsdata.modalModifShow;
    const id = useSelector(state => state.userData.id);

    const [loading,setLoading] =useState(false)
    const [etat,setEtat] =useState('')

    const designationField=useRef('')
    const contactField=useRef('')
    const telField=useRef('')
    const iceField=useRef('')
    const villeField=useRef('')
    const ribField=useRef('')
    

    const ChampUpdate = () =>{
        const _id=currentelement._id;
        const designation=designationField.current.value;
        const contact=contactField.current.value;
        const tel=telField.current.value;
        const ice=iceField.current.value;
        const ville=villeField.current.value;
        const rib=ribField.current.value;

        const data={_id,designation,contact,tel,ice,ville,rib};
        dispatch(current(data));
    }

    const Ajouter = async ()=> {
        const designation=designationField.current.value;
        const contact=contactField.current.value;
        const tel=telField.current.value;
        const ice=iceField.current.value;
        const ville=villeField.current.value;
        const rib=ribField.current.value;


        if(designation==="")
            {
                alert("Désignation vide");
                return;
            }
            setEtat('')
            setLoading(true)
        try {
            const apiUrl = process.env.REACT_APP_API_URL;
            const idclient = currentelement._id;
            const response = await axios.post(`${apiUrl}edit/client/${id}/${idclient}`, {
                designation,
                contact,
                tel,
                ice,
                ville,
                rib,
            });
            if(response.data.status==="ok")
                {
                    const data={idclient,designation,contact,tel,ice,ville,rib};
                    dispatch(modalModifShow(false));
                    dispatch(modif(true));
                    dispatch(update(data));
                }
            else{
                setEtat('erreur');
            }
        } catch (error) {
            setEtat('erreur');
        }
        setLoading(false)
    }

    const dispatch= useDispatch();
    const Close = () => {
        dispatch(modalModifShow(false));
        setEtat('');
        
    };

    useEffect(() =>{
        setEtat('');
      },[]);

    return (
        <div className={`modal fade ${modalShow ? 'show' : ''}`} style={{ display: modalShow ? 'block' : 'none' }} role="dialog" aria-hidden="true">
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Modifier client</h5>
                    </div>
                    <div className="modal-body">
                    {etat==='erreur' ?
                                <div class="alert alert-danger  mb-4 text-center" role="alert">
                                <strong>Erreur de connexion</strong>
                            </div>                 
                        :
                        ''                    
                    }
                    <label className="form-label" for="designation">Nom client</label>
                    <input type="text" className="form-control" id="designation" onChange={ChampUpdate} value={currentelement.designation} ref={designationField}></input>

                    <label className="form-label" for="contact">CIN</label>
                    <input type="text" className="form-control" id="contact" onChange={ChampUpdate} value={currentelement.contact} ref={contactField}></input>

                    <label className="form-label" for="tel">Tel.</label>
                    <input type="text" className="form-control" id="tel" onChange={ChampUpdate} value={currentelement.tel} ref={telField}></input>

                    <label className="form-label" for="ice">ICE</label>
                    <input type="text" className="form-control" id="ice" onChange={ChampUpdate} value={currentelement.ice} ref={iceField}></input>

                    <label className="form-label" for="ville">Adresse</label>
                    <input type="text" className="form-control" id="ville" onChange={ChampUpdate} value={currentelement.ville} ref={villeField}></input>

                    <label className="form-label" for="ville">RIB</label>
                    <input type="text" className="form-control" id="ville" onChange={ChampUpdate} value={currentelement.rib} ref={ribField}></input>

                    </div>
                    <div className="modal-footer">
                        {loading ?
                        <>
                <div className="mt-4 d-flex justify-content-center">
                <button class="btn btn-success" type="button" disabled>
                <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                <span class="sr-only">Enregistrement...</span>
                </button>
                </div> 
                        </>
                        :
                        <>
                        <button type="button" className="btn btn-success" onClick={Ajouter}>Enregistrer</button>
                        <button type="button" className="btn btn-secondary" onClick={Close}>Annuler</button>
                        </>
                        }
                    </div>
                </div>
            </div>
        </div>
    );

    }


